import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  // 대시보드 레이아웃 감시용 (row, column)
  private dashboardSource = new Subject<string>();
  public dashboard$ = this.dashboardSource.asObservable();
  public changeDashboard(dashboard: string) {
    this.dashboardSource.next(dashboard);
  }

  // 대시보드 레이아웃 클릭변경 감시용 (group: 1, date: 2, user: 3)
  private layoutSource = new Subject<string>();
  public layout$ = this.layoutSource.asObservable();
  public changeLayout(layout: string) {
    this.layoutSource.next(layout);
  }

  // 대시보드 그룹 클릭 감시용
  private groupSource = new Subject<any>();
  public group$ = this.groupSource.asObservable();
  public changeGroup(group: any) {
    this.groupSource.next(group);
  }

  // 대시보드 날짜 클릭 감시용
  private chartDateSource = new Subject<any>();
  public chartDate$ = this.chartDateSource.asObservable();
  public changeChartDate(chartDate: any) {
    this.chartDateSource.next(chartDate);
  }

  // 대시보드 사용자 클릭 감시용
  private userSource = new Subject<any>();
  public user$ = this.userSource.asObservable();
  public changeUser(user: any) {
    this.userSource.next(user);
  }

  // 대시보드 에이전트 클릭 감시용
  private agentSource = new Subject<any>();
  public agent$ = this.agentSource.asObservable();
  public changeAgent(agent: any) {
    this.agentSource.next(agent);
  }

  // 대시보드2 타입변경 감시용
  private layout2TypeSource = new Subject<any>();
  public layout2Type$ = this.layout2TypeSource.asObservable();
  public changeLayout2Type(layout2Type: any) {
    this.layout2TypeSource.next(layout2Type);
  }

  // 대시보드 날짜차트 툴팁표시 감시용
  private chartTooltipShowSource = new Subject<any>();
  public chartTooltipShow$ = this.chartTooltipShowSource.asObservable();
  public changeChartTooltipShow(chartTooltipShow: any) {
    this.chartTooltipShowSource.next(chartTooltipShow);
  }

  // 대시보드 날짜차트 툴팁숨김 감시용
  private chartTooltipHideSource = new Subject<any>();
  public chartTooltipHide$ = this.chartTooltipHideSource.asObservable();
  public changeChartTooltipHide(chartTooltipHide: any) {
    this.chartTooltipHideSource.next(chartTooltipHide);
  }

  // 대시보드 날짜차트 툴팁고정 감시용
  private chartTooltipFixSource = new Subject<any>();
  public chartTooltipFix$ = this.chartTooltipFixSource.asObservable();
  public changeChartTooltipFix(chartTooltipFix: any) {
    this.chartTooltipFixSource.next(chartTooltipFix);
  }

  // 모니터링용
  private monitoringSource = new Subject<any>();
  public monitoring$ = this.monitoringSource.asObservable();
  public changeMonitoring(monitoring: any) {
    this.monitoringSource.next(monitoring);
  }

  // 모니터링용
  private mapTypeSource = new Subject<any>();
  public mapType$ = this.mapTypeSource.asObservable();
  public changeMapType(mapType: any) {
    this.mapTypeSource.next(mapType);
  }

  // 서버상태확인
  private serverOnSource = new Subject<any>();
  public serverOn$ = this.serverOnSource.asObservable();
  public changeServerOn(serverOn: any) {
    this.serverOnSource.next(serverOn);
  }

  /**
   * 헤더 로고 클릭 시 대시보드 메인 화면으로 이동
   */
  private logoClick: any = new Subject<string>();
  public logoClick$ = this.logoClick.asObservable();
  public changeLogoClickValue(logoClick: string) {
    this.logoClick.next(logoClick);
  }

  /**
   * 지도 유지 생성 및 유지 감시
   */
  private mapInit: any = new Subject<string>();
  public mapInit$ = this.mapInit.asObservable();
  public mapInitValue(mapInit: string) {
    this.mapInit.next(mapInit);
  }
}
